import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import { IconButton, Link, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { ASSET_DISABLE_METHODS_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import LicenseForm from "./LicenseForm";
import DisposalMethodForm from "./DisposalMethodForm";

function DisposalMethodDialog({
    assetDisposalMethodId: assetDisposalMethodId = "",
    assetDisposalMethodName: assetDisposalMethodName,
    variant = "button", // 'button' for add, 'link' for edit
    onSuccess,
}) {
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleClickOpen = async () => {
        if (assetDisposalMethodId && assetDisposalMethodId !== "") {
            setLoading(true);
            try {
                const response = await AxiosInstance.get(
                    `${ASSET_DISABLE_METHODS_URL}/${assetDisposalMethodId}`
                );
                setEditData(response.data);
                setOpen(true);
            } catch (error) {
                console.error("Error fetching Asset Disposal Method data:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setEditData(null);
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setEditData(null);
    };

    const renderTrigger = () => {
        if (variant === "link" && assetDisposalMethodId) {
            return (
                <Link
                    component="button"
                    onClick={handleClickOpen}
                    disabled={loading}
                    sx={{
                        cursor: "pointer",
                        textDecoration: "none",
                        color: "primary.main",
                        "&:hover": {
                            textDecoration: "underline",
                        },
                    }}
                >
                    {assetDisposalMethodName}
                </Link>
            );
        }

        return (
            <Tooltip
                title="Asset Status"
                onClick={handleClickOpen}
                disabled={loading}
            >
                <IconButton
                    sx={{
                        cursor: "pointer",
                        margin: "2px",
                        color: (theme) => theme.palette.grey[500],
                        borderRadius: 2,
                        border: 1,
                        borderColor: "divider",
                    }}
                >
                    <AddTaskOutlinedIcon color="primary" />
                </IconButton>
            </Tooltip>
        );
    };

    return (
        <>
            {renderTrigger()}
            <DisposalMethodForm
                open={open}
                onClose={handleClose}
                editData={editData}
                onSuccess={onSuccess}
                isEditMode={Boolean(editData)}
            />
        </>
    );
}
export default DisposalMethodDialog;
